import { FaBarcode } from "react-icons/fa";
import Tooltip from "../ToolTip";

const IdButton = ({ action, content, type = "eye" }) => {
  return (
    <Tooltip content={content}>
      <button
        onClick={() => action ? action() : null}
        className="p-1.5 text-yellow-500 hover:bg-yellow-600 hover:bg-opacity-25 hover:cursor-pointer rounded-md bg-yellow-700 bg-opacity-10 flex transition-all duration-100 items-center"
      >
         <FaBarcode className="text-[10px]"/>
      </button>
    </Tooltip>
  )
}

export default IdButton;